import { tap, debounceTime, switchMap, groupBy, mergeMap } from "rxjs/operators";
import { Observable } from "rxjs";
import { formOperation } from "../../wrappers/formOperation";
import { TActionsDefinitionsList } from "./TAction";
import { action } from "./actionFunctions";
import { TLenderForm } from "../../../../domain/codecs/form/LenderForm";

export const actions: TActionsDefinitionsList = [
    action("CRM_LENDER_CHANGE", (obs$: Observable<TLenderForm>, lens, set) => {
        obs$.pipe(
            tap((form) => set(lens.lenders_page_form.children.lender_forms.where(({edited}) =>
                edited.lender_name === form.edited.lender_name
            ).set(form))),
            groupBy((form) => form.edited.lender_name),
            mergeMap((group$) => group$.pipe(
                debounceTime(1000),
                switchMap((form) => formOperation("UpdateLender", form)),
                tap((response) => set(lens.lenders_page_form.children.lender_forms.where(({edited}) =>
                    edited.lender_name === response.edited.lender_name
                ).set(response))),
            )),
        ).subscribe();
    }),
];
